import React from 'react';
import PropTypes from 'prop-types';

const LabeledCheckbox = (props) => {
  const { name, label, error, ...rest } = props;

  return (
    <div className={`labeledCheckbox ${error ? 'border--error' : ''}`}>
      <input className="checkbox" name={name} {...rest} />
      <label className="label" htmlFor={name}>
        {label}
      </label>
    </div>
  );
}

LabeledCheckbox.propTypes = {
  type: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  value: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default LabeledCheckbox;



// WEBPACK FOOTER //
// ./src/components/LabeledCheckbox.js